var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 18,
    fill: "none",
    viewBox: "0 0 25 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#97A2AB",
    d: "M19.125 16.313c.934 0 1.688-.754 1.688-1.688 0-.934-.754-1.688-1.688-1.688-.934 0-1.688.754-1.688 1.688 0 .934.754 1.688 1.688 1.688zm1.688-10.125H18V9h5.017l-2.204-2.813zM5.624 16.313c.934 0 1.688-.754 1.688-1.688 0-.934-.754-1.688-1.688-1.688-.934 0-1.688.754-1.688 1.688 0 .934.754 1.688 1.688 1.688zM21.375 4.5L24.75 9v5.625H22.5c0 1.867-1.508 3.375-3.375 3.375s-3.375-1.508-3.375-3.375H9C9 16.492 7.492 18 5.625 18c-1.868 0-3.375-1.508-3.375-3.375H0V2.25C0 1.001 1.001 0 2.25 0H18v4.5h3.375zM2.25 2.25v10.125h.855c.619-.686 1.519-1.125 2.52-1.125 1.001 0 1.901.439 2.52 1.125h7.605V2.25H2.25zm7.875 1.125l3.938 3.938-3.938 3.937V8.437H4.5v-2.25h5.625V3.376z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/truck-icon.d9d9fb993095a688fb994da71a1a07e9.svg";
export { ForwardRef as ReactComponent };